import { render } from "./AskAQuestionView.vue?vue&type=template&id=92e44d3c&scoped=true&ts=true&lang=pug"
import script from "./AskAQuestionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AskAQuestionView.vue?vue&type=script&lang=ts&setup=true"

import "./AskAQuestionView.vue?vue&type=style&index=0&id=92e44d3c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92e44d3c"]])

export default __exports__